/**
* @brandOverride URBNWeb
*/
import { categoryReducer } from '../reducers/categoryReducer';
import { cacheReducer } from '../reducers/cacheReducer';
import { coreReducer } from '../../../core/js/reducers/coreReducer';
import { pdpReducer } from '../../../product/js/reducers/productReducer';
import { quickshopReducer } from '../../../product/js/reducers/quickshopReducer';
import { registryReducer } from '../../../registry/js/reducers/registryReducer';

function categoryApp(state = {}, action) {
    return {
        cache: cacheReducer(state.cache, action),
        category: categoryReducer(state.category, state.core.routeInfo, action),
        core: coreReducer(state.core, action),
        product: pdpReducer(state, state.product, action),
        quickshop: quickshopReducer(state, state.quickshop, action),
        registry: registryReducer(state.registry, action)
    };
}

export default categoryApp;
